/* tslint:disable */
/* eslint-disable */
export enum FileStatus {
  Approvable = 'Approvable',
  NotApprovable = 'NotApprovable',
  Approved = 'Approved',
  Rejected = 'Rejected',
  PendingApproval = 'PendingApproval',
  PendingRejection = 'PendingRejection',
  ApprovalProcessingFailed = 'ApprovalProcessingFailed',
  RejectionProcessingFailed = 'RejectionProcessingFailed'
}
